// extracted by mini-css-extract-plugin
export default {"text-h1":"NotFound_text-h1__OPJuz","text-p":"NotFound_text-p__ijA1l","text-button":"NotFound_text-button__RoTUB"};